import {
	IconCheckOutline18 as Check,
	IconCircleInfoOutline18 as CircleInfo,
	IconCircleWarningOutline18 as CircleWarning,
	IconLightbulbOutline18 as Lightbulb,
	IconOctagonWarningOutline18 as OctagonWarning,
	IconTriangleWarningOutline18 as TriangleWarning,
} from "nucleo-ui-outline-18"

import type { CalloutVariant } from "@productlane/lib/src/tiptap/extensions/callout-variant"
import { cn } from "@productlane/lib/src/cn"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

const calloutCommand = ({
	key,
	title,
	variant,
	icon,
	aliases,
}: {
	key: string
	title: string
	variant: CalloutVariant
	icon: React.ReactElement
	aliases: string[]
}): SlashCommandDefinition => ({
	key,
	title,
	icon,
	aliases,
	group: "blocks",
	command: ({ editor, range }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.setBlockquote()
			.setCalloutVariant(variant)
			.run()
	},
})

const iconClass = cn("h-[16px] w-[16px]", iconClassName)

export const noteCalloutCommand = calloutCommand({
	key: "callout-note",
	title: "Note callout",
	variant: "note",
	aliases: ["note", "blue", "callout"],
	icon: <CircleWarning className={cn(iconClass, "text-blue-600")} />,
})

export const infoCalloutCommand = calloutCommand({
	key: "callout-info",
	title: "Info callout",
	variant: "neutral",
	aliases: ["info", "gray", "callout"],
	icon: <CircleInfo className={cn(iconClass, "text-gray-600")} />,
})

export const tipCalloutCommand = calloutCommand({
	key: "callout-tip",
	title: "Tip callout",
	variant: "tip",
	aliases: ["tip", "hint", "green", "callout"],
	icon: <Lightbulb className={cn(iconClass, "text-green-600")} />,
})

export const checkCalloutCommand = calloutCommand({
	key: "callout-check",
	title: "Check callout",
	variant: "check",
	aliases: ["check", "success", "done", "green", "callout"],
	icon: <Check className={cn(iconClass, "text-green-600")} />,
})

// The slash menu still registers this name; it now inserts Mintlify's Check.
export const successCalloutCommand = checkCalloutCommand

export const warningCalloutCommand = calloutCommand({
	key: "callout-warning",
	title: "Warning callout",
	variant: "warning",
	aliases: ["warning", "caution", "yellow", "callout"],
	icon: <TriangleWarning className={cn(iconClass, "text-yellow-600")} />,
})

export const dangerCalloutCommand = calloutCommand({
	key: "callout-danger",
	title: "Danger callout",
	variant: "danger",
	aliases: ["danger", "error", "red", "callout"],
	icon: <OctagonWarning className={cn(iconClass, "text-red-600")} />,
})
